import { getApprovalKey, getPayUrl, PaymentRequestInterface, submitPayment } from '@apis/payment';
import { Button } from 'antd';
import { FC, useState } from 'react';
import { axiosInstance } from 'src/axios/useRequest';
import { IFooterProps } from './Footer';

const PaymentTemplates: FC<Partial<IFooterProps>> = ({ param, bnameList, orderId, regType }) => {
  const [loading, isLoading] = useState(false);
  
  /** 결제 요청 파라미터 생성 */
  const paymentParams = (): PaymentRequestInterface => {
    return {
      dest: param?.ctryCode ?? '',
      embassyCode: param?.embassyCode ?? '',
      bnameList: bnameList ?? '',
      bname: param?.buyerName ?? '',
      btel: param?.phoneNumber ?? '',
      bemail: param?.email ?? '',
      pay_method: 'CARD',
      ordr_idxx: String(orderId ?? ''),
      reg_type: regType ?? 'web',
      good_mny: String(param?.totalAmount ?? 0),
      good_name: param?.serviceName ?? '',
      insurcYn: param?.insurcYn ?? '',
      gogreenYn: param?.gogreenYn ?? '',
      ret_URL: `${process.env.REACT_APP_API_HOST}/dhl/kr/epass/customer/api/payments/success`, // 결제 성공 시 이동할 페이지
      fail_url: `${process.env.REACT_APP_API_HOST}/dhl/kr/epass/customer/api/payments/fail`,   // 결제 실패 시 이동할 페이지
    };
  };

  /** 숨은 폼 POST로 결제창 실행 */
  const postToKcp = (payUrl: string, fields: Record<string, string>) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = payUrl;
    form.acceptCharset = 'UTF-8';

    Object.entries(fields).forEach(([k, v]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = k;
      input.value = v ?? '';
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };
  
  const handleSubmit = async () => {
    isLoading(true);
    
    const consentList = [
      ...(param?.isPrivAgree1
        ? [{ consentStatus: 'G', consentTemplateID: '000124' }]
        : []),
      ...(param?.isPrivAgree2
        ? [{ consentStatus: 'G', consentTemplateID: '000126' }]
        : []),
      ...(param?.isPrivAgree3
        ? [{ consentStatus: 'G', consentTemplateID: '000128' }]
        : []),
      ...(param?.isPrivAgree4
        ? [{ consentStatus: 'G', consentTemplateID: '000130' }]
        : []),
      ...(param?.isMktAgree1 === true
        ? [{ consentStatus: 'G', consentTemplateID: '000132' }]
        : param?.isMktAgree1 === false
          ? [{ consentStatus: 'W', consentTemplateID: '000132' }]
          : []),
      ...(param?.isMktAgree2 === true
        ? [{ consentStatus: 'G', consentTemplateID: '000134' }]
        : param?.isMktAgree2 === false
          ? [{ consentStatus: 'W', consentTemplateID: '000134' }]
          : []),
    ];
  
    try {
      // 1. 개인정보 동의 저장 API 호출
      const consentResponse = await axiosInstance.post('/dhl/kr/cmp/performCustomerConsentInfo', {
        email: param?.email,
        familyName: param?.lastName,
        firstName: param?.firstName,
        mobile: param?.phoneNumber,
        consentList: consentList,
      });

      if (consentResponse?.data?.resultCd !== 'SUCCESS') {
        console.warn('개인정보 동의 저장 실패:', consentResponse?.data?.resultMsg);
      }
      
    } catch (err) {
      console.error('CMP API 오류', err);
      console.error('개인정보 동의 저장 중 오류가 발생했습니다.');
    }

    // 동의 성공/실패와 무관하게 결제는 항상 실행
    try {
      
      // 1) 거래등록 호출
      const tregReq = paymentParams();
      const tregRes = await submitPayment(tregReq);

      const code = tregRes.code ?? tregRes.Code;
      const payUrl = getPayUrl(tregRes);
      const approvalKey = getApprovalKey(tregRes);

      if (code !== '0000' || !payUrl || !approvalKey) {
        console.error('TREG response:', tregRes);
        alert('결제창 정보를 가져오지 못했습니다.');
        return;
      }

      // 2) 결제창 실행에 필요한 파라미터 준비 (최소 요건)
      const fields: Record<string, string> = {
        // 필수
        ordr_idxx: String(orderId ?? ''),
        shop_user_id: param?.email ,
        approval_key: approvalKey,
        // 권장
        site_name: 'DHL EXPRESS KOREA TEST',
        site_logo: `${process.env.REACT_APP_KR_CUSTOMER_URL}/DHL_logo.gif`,
        skin_indx: '1',
        eng_flag: 'N',
        good_expr: '0',
        good_cd: '00',
      };
      postToKcp(payUrl, fields);

    } catch (e: any) {
      console.error(e);
      alert('결제 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.');
    } finally {
      isLoading(false);
    }
  };

  return (
    <Button loading={loading} onClick={handleSubmit}>
      결제하기
    </Button>
  );
};

export default PaymentTemplates;
